/**
 * Текст ошибки от API.
 *
 * Сервер кладёт сообщение в `message`: `statusMessage` — это значение из HTTP
 * status line, куда кириллица не помещается и приходит обрезанной, и h3
 * собирается его санитизировать. Старое поле читаем следом — на случай
 * ответа от обработчика, который ещё не перевели.
 */
/** Где чинить отказ: ворота стадии называют место (`move-stage.ts`) */
export function apiErrorFix(e: unknown): string | null {
  return (e as { data?: { data?: { fix?: string } } })?.data?.data?.fix ?? null
}

export function apiErrorMessage(e: unknown, fallback = 'Что-то пошло не так'): string {
  const err = e as {
    data?: { message?: string; statusMessage?: string }
    message?: string
  }

  return err?.data?.message || err?.data?.statusMessage || err?.message || fallback
}
